import React, { Component } from "react";
import "./Button.css";

class Button extends Component {
	// Standard console button
	render() {
		return (
			<button className="fm-standard-button" onClick={this.props.onClick}>
				{this.props.label}
			</button>
		);
	}
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button/Button.js